var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "",
        "lock-scroll": false,
        "append-to-body": "",
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("template", { slot: "title" }, [
        _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [_c("div")]
        ),
      ]),
      _c(
        "el-row",
        [
          _c(
            "el-input",
            {
              attrs: {
                placeholder: "菜单搜索，支持菜单名称模糊搜索",
                clearable: "",
              },
              on: { input: _vm.filterList },
              model: {
                value: _vm.input,
                callback: function ($$v) {
                  _vm.input = $$v
                },
                expression: "input",
              },
            },
            [
              _c("i", {
                staticClass: "el-input__icon el-icon-search",
                attrs: { slot: "prefix" },
                slot: "prefix",
              }),
            ]
          ),
          _c(
            "div",
            { staticStyle: { height: "500px", "margin-top": "20px" } },
            [
              _c(
                "div",
                { staticStyle: { "max-height": "300px", overflow: "auto" } },
                [
                  _vm._l(_vm.filteredList, function (item) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "searchitem",
                          on: {
                            click: function ($event) {
                              return _vm.goDetailAct(item)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(item.name) + " ")]
                      ),
                      _vm.filteredList.length
                        ? _c("div", { staticClass: "line" })
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "flex-start",
                    "margin-top": "20px",
                    "flex-direction": "column",
                  },
                },
                [
                  _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                    _vm._v("最近常用"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "searchBack" },
                    _vm._l(_vm.recentList, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          staticClass: "historyitem",
                          on: {
                            click: function ($event) {
                              return _vm.goDetailAct(item)
                            },
                          },
                        },
                        [
                          _c("div", { staticStyle: { flex: "1" } }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                          _c("i", {
                            staticClass: "el-icon-close",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.deleteAct(item)
                              },
                            },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }